'use client';

import { signIn, useSession } from 'next-auth/react';

import { Button } from 'components/ui/button';

export function LoginButtonAzure() {
  const { status } = useSession();
  const loading = status === 'loading';

  async function handleLogin() {
    await signIn('azure-ad', { redirectTo: '/' });
  }

  return (
    <Button
      loading={loading}
      onClick={handleLogin}
      className="w-full flex items-center bg-[#035bda] text-white hover:bg-[#0353c3] border-[#035bda]"
      icon={<AzureLogo />}
    >
      <span>Sign in with Azure</span>
    </Button>
  );
}

export function AzureLogo() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="24" height="24">
      <path
        fill="#ffffff"
        d="M46 40L29.317 10.852 22.808 23.96 34.267 37.24 13 39.655zM13.092 18.182L2 36.896 11.442 35.947 28.033 5.678z"
      />
    </svg>
  );
}
